import { redirect } from "react-router";
import api from "./api";

export async function action({ request }) {
  const method = request.method;
  const data = await request.formData();

  let tags = data.getAll("tags");
  tags = [...new Set(tags)];

  const fieldData = {
    ofid: data.get("ofid"),
    fieldName: data.get("fieldName"),
    dataType: data.get("dataType"),
    description: data.get("description"),
    values: data.get("values"),
    level: data.get("level"),
    tags: tags,
    example: data.get("example"),
    linkReference: data.get("linkReference"),
    standardRefs: JSON.parse(data.get("standardRefs") || "[]"),
    introducedArray: data.get("introducedArray"),
    deprecatedArray: data.get("deprecatedArray"),
    uploadedFile: data.get("uploadedFile"),
  };

  await api({
    method: method,
    url: `/record`,
    data: fieldData,
  });

  return redirect("..");
}
